import { AlertCircle, CheckCircle2, Info, X } from 'lucide-react';

import { useToast } from '@/components/ui/use-toast';
import { cn } from '@/lib/utils';

const ICONS = {
  default: Info,
  success: CheckCircle2,
  destructive: AlertCircle,
};

/** Renders once at the app root — see AppShell. */
export function Toaster() {
  const { toasts, dismiss } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 z-[100] flex flex-col items-center gap-2 p-4 sm:items-end">
      {toasts.map((t) => {
        const Icon = ICONS[t.variant ?? 'default'];
        return (
          <div
            key={t.id}
            role="status"
            className={cn(
              'pointer-events-auto flex w-full max-w-sm items-start gap-3 rounded-2xl border p-4 shadow-lg animate-in slide-in-from-bottom-4 fade-in-0',
              'border-border/60 bg-popover',
            )}
          >
            <span
              className={cn(
                'mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-xl',
                t.variant === 'success' && 'bg-mint-soft text-mint-deep',
                t.variant === 'destructive' && 'bg-status-out/15 text-status-out',
                (!t.variant || t.variant === 'default') && 'bg-sky-soft text-sky-deep',
              )}
            >
              <Icon className="h-4 w-4" />
            </span>
            <div className="flex-1 text-sm">
              <p className="font-medium text-foreground">{t.title}</p>
              {t.description && <p className="mt-0.5 text-muted-foreground">{t.description}</p>}
            </div>
            <button
              onClick={() => dismiss(t.id)}
              className="shrink-0 rounded-sm text-muted-foreground hover:text-foreground"
              aria-label="Dismiss"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}